import { Pipe, PipeTransform } from '@angular/core';
import { Observable, interval, of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Pipe({
    name: 'vsViewDate',
    pure: true
})
export class VsViewDatePipe implements PipeTransform {
    transform(createdDate: any): Observable<string> {
        if (!(createdDate instanceof Date)) {
            createdDate = new Date(createdDate);
        }

        const currentDate = new Date();
        currentDate.setHours(currentDate.getHours() + 7);
        const timeDifference = currentDate.getTime() - createdDate.getTime();
        const minutes = Math.floor(timeDifference / 1000 / 60);

        // Nếu >= 60 phút, không cần cập nhật tự động
        if (minutes >= 60) {
            return of(this.formatRelativeTime(createdDate));
        }

        // Nếu < 60 phút, cập nhật mỗi 1 phút
        return interval(60000).pipe(
            startWith(0),
            map(() => this.formatRelativeTime(createdDate))
        );
    }

    private formatRelativeTime(createdDate: Date): string {

        const currentDate = new Date();
        currentDate.setHours(currentDate.getHours() + 7);

        const timeDifference = currentDate.getTime() - createdDate.getTime();

        const secondsPerMinute = 60;
        const minutesPerHour = 60;
        const hoursPerDay = 24;
        const daysPerWeek = 7;

        const seconds = Math.floor(timeDifference / 1000);
        const minutes = Math.floor(seconds / secondsPerMinute);
        const hours = Math.floor(minutes / minutesPerHour);
        const days = Math.floor(hours / hoursPerDay);
        const weeks = Math.floor(days / daysPerWeek);

        if (weeks > 0) {
            return `${weeks} tuần`;
        } else if (days > 0) {
            return `${days} ngày`;
        } else if (hours > 0) {
            return `${hours} giờ`;
        } else if (minutes > 0) {
            return `${minutes} phút`;
        } else if (seconds > 0) {
            return `${seconds} giây`;
        } else {
            return "vừa xong";
        }
    }
}
// Cách dùng: {{item.updatedDate | vsViewDate | async}}
